module.exports = __webpack_public_path__ + "static/img/py.bbc22e41.svg";